import * as React from "react";
import { DeckComponent } from "./DeckComponent";
import { InvestigatorPortraitComponent } from "./InvestigatorPortrait";
import { IScenarioState } from "./Scenario";
import { GameToken } from "./Card";
import { InvestigatorHandComponent } from "./InvestigatorHand";
import { LocationMenuItemComponent } from "./LocationMenuItemComponent";
import { InvestigatorUtil } from "./InvestigatorUtil";

export interface IActiveLocationProps {
    state: IScenarioState;

    locationId: number;
    onChanged: () => void;
}
export class ActiveLocationComponent extends React.Component<IActiveLocationProps, any> {
    removeCurrentLocation() {
        const activeLocId = LocationMenuItemComponent.getCurrentSelectedLocationId(this.props.state);
        this.props.state.locations.filter(l => l.card.packNumber === activeLocId)[0].inactive = true;
        this.props.onChanged();
    }
    moveInvestigatorToLast(index: number) {
        InvestigatorUtil.moveInvestigatorToLast(this.props.state,this.props.locationId,index);
        this.props.onChanged();
    }
    render() {
        const location = this.props.state.locations.filter(l => l.card.packNumber === this.props.locationId)[0];
        const deck = { cards: [location.card] };
        const inv: JSX.Element[] = [];
        const investigators = InvestigatorUtil.getInvestigatorsOnLocation(this.props.state,this.props.locationId);
        for (let i = 0; i < investigators.length; i++) {
            const index = this.props.state.investigators.indexOf(investigators[i]);
            const orderedIndexOnLocation = i;
            inv.push((<li key={index} onClick={() => { this.moveInvestigatorToLast(orderedIndexOnLocation) }}><InvestigatorPortraitComponent investigator={investigators[i]} index={index} onChanged={() => this.props.onChanged()} /></li>));
        }
        const deckSettings = {
            hideTokensOnFront: true,
            allowedTokens: [GameToken.Clue],
            toolbar: {
                align: "right",
                actions: [
                    {
                        title: "Remove location",
                        icon: "glyphicon glyphicon-remove",
                        minNoOfCards:1,
                        action: () => this.removeCurrentLocation()
                    }
                ]
            }
        };
        return (
            <div>
                <div className="player-area">
                    <ul>{inv}</ul>
                </div>
                <div className="location">
                    <DeckComponent horizontal={false} deck={deck} onChanged={() => this.props.onChanged()}
                        settings={deckSettings} />
                </div>
                <div className="enemies">
                    <InvestigatorHandComponent deck={location.enemies} settings={{ toolbar: { zoom: true, navigation: true,exhaust:true } }} onChanged={() => this.props.onChanged()} />
                </div>
            </div>
        );
    }
}
